import { useGetApprovalParticipationQuery } from 'features/comments/approvalApi';

/**
 * @param {string} [uri]
 * @returns {import('models/approval.models').ApprovalParticipation | undefined}
 */
export function useGetApprovalParticipation(uri) {
    const results = useGetApprovalParticipationQuery(uri, {
        skip: uri === undefined,
    });

    return results?.currentData;
}
